define('home/models/formatting/LinkPopover',[
    'backbone',
], function (
    Backbone
) {
    'use strict';

    var isEmpty = function (val) {
        return !(val && val.trim());
    };

    var LinkPopover = Backbone.Model.extend({
        defaults: {
            originalText: '',
            text: '',
            url: '',
        },

        validate: function (attrs) {
            if (isEmpty(attrs.text)) {
                return {
                    attrName: 'text',
                    message: 'Link text is required.',
                };
            }

            if (isEmpty(attrs.url)) {
                return {
                    attrName: 'url',
                    message: 'Link URL is required.',
                };
            }
        },
    });

    return LinkPopover;
});

